import store from "@/store"
import home from "@/components/userView/home.vue"
function loadUserView(view) {
    return () => import( /* webpackChunkName: "userview-[request]" */ `@/components/userView/${view}.vue`)
}
function loadView(view) {
  return () => import( /* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`)
}
const homeRoute = [
    {
        path: '',
        name: 'Landing Page',
        meta: {
          requiresAuth: false,
          roleVerif: false,
          role: []
        },
        component: home,
    },
    {
        path: '/perusahaan',
        name: 'Company List',
        meta: {
          requiresAuth: false,
          roleVerif: false,
          role: []
        },
        component: loadUserView('companyList'),
    },
    {
        path: '/informasi',
        name: 'announcementList',
        meta: {
          requiresAuth: false,
          roleVerif: false,
          role: []
        },
        component: loadUserView('announcementList'),
    },
    {
        path: '/informasi/:slug',
        name: 'announcementDetail',
        meta: {
          requiresAuth: false,
          roleVerif: false,
          role: []
        },
        component: loadUserView('announcementDetail'),
    },
    {
        path: '/perusahaan/:slug',
        name: 'Company Detail',
        meta: {
          requiresAuth: false,
          roleVerif: false,
          role: []
        },
        component: loadUserView('companyDetail'),
    },
    {
        path: '/lowongan-pekerjaan',
        name: 'Job Vacancy',
        meta: {
          requiresAuth: false,
          roleVerif: false,
          role: []
        },
        component: loadUserView('jobVacancy'),
    },
    {
        path: '/lowongan-pekerjaan/:slug',
        name: 'Job Vacancy Detail',
        meta: {
          requiresAuth: false,
          roleVerif: false,
          role: []
        },
        component: loadUserView('jobVacancyDetail'),
    },
    {
        path: '/status-lamaran',
        name: 'Job Vacancy Status',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['aln', 'mhs']
        },
        component: loadUserView('jobVacancyStatus'),
    },
    {
        path: '/pengaturan-akun',
        name: 'Setting',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['aln', 'mhs']
        },
        component: loadUserView('setting'),
    },
    {
        path: '/profile',
        name: 'Profile',
        meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['aln', 'mhs']
        },
        component: loadUserView('profile'),
    },
    {
      path: '/expired-link',
      name: 'ExpiredLink',
      meta: {
          requiresAuth: false,
          roleVerif: false,
          role: []
      },
      component: loadView('ExpiredLink')
    },
    {
      path: '*',
      name: 'NotFound',
      meta: {
          requiresAuth: false,
          roleVerif: false,
          role: []
      },
      component: loadView('NotFound')
    }
]
const routerFilter = async () => {
  await store.restored;
  const myrole = store.getters["auth/getRole"];
  const isLoggedIn = store.getters['getisLoggedIn']
  return homeRoute.filter((row) => {
    return (row.meta.requiresAuth == isLoggedIn && ((row.meta.roleVerif && row.meta.role.some(role => role == myrole) || !row.meta.roleVerif))) || !row.meta.requiresAuth
  })
}
export default routerFilter()